<template>
  <el-dialog
    class="import-org-cert-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    top="21vh"
  >
    <el-form
      ref="editForm"
      :model="editForm"
      :rules="editRules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
    >
      <el-form-item label="组织ID" prop="OrgId">
        <el-input v-model="editForm.OrgId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="组织名称" prop="OrgName">
        <el-input v-model="editForm.OrgName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="密码算法" prop="Algorithm">
        <el-select v-model="editForm.Algorithm" placeholder="请选择" clearable class="auto-width">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="组织CA证书" prop="CaCert">
        <upload-files ref="orgCert"></upload-files>
      </el-form-item>
      <el-form-item label="组织CA私钥" prop="CaKey">
        <upload-files ref="orgKey"></upload-files>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleOk()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'ImportOrgCert',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 108
  },
  data() {
    return {
      title: '导入IBC组织证书',
      dialogVisible: false,
      disabled: false,
      editForm: {
        OrgId: '',
        OrgName: '',
        Algorithm: 2,
        CaCert: 'CaCert',
        CaKey: 'CaCert',
        Type: 0
      },
      editRules: {
        OrgId: [{ required: true, message: '请填写组织ID', trigger: 'blur' }],
        Algorithm: [{ required: true, message: '请选择密码算法', trigger: 'blur' }],
        OrgName: [{ required: true, message: '请输入组织名称', trigger: 'blur' }],
        CaCert: [{ required: true, message: '请上传组织CA证书', trigger: 'blur' }],
        CaKey: [{ required: true, message: '请上传组织CA私钥', trigger: 'blur' }]
      },
      options: [
        // { label: '国密', value: 0 },
        // { label: 'ECDSA', value: 1 },
        { label: 'IBC', value: 2 }
      ],
      adaptationVars: {
        formLabelWidth: 108
      }
    }
  },
  methods: {
    handleCancel() {
      this.editForm = {
        OrgId: '',
        OrgName: '',
        Algorithm: 2,
        CaCert: 'CaCert',
        CaKey: 'CaCert',
        Type: 0
      }
      this.disabled = false
      this.$refs.editForm.clearValidate()
      this.$refs.orgCert.clear()
      this.$refs.orgKey.clear()
      this.dialogVisible = false
    },
    handleOpen() {
      this.dialogVisible = true
    },
    handleOk() {
      // const testResult = this.$utils.checkCertificateName(this.editForm.OrgName)
      // if (testResult) {
      //   this.$message.error(testResult)
      //   return;
      // }
      this.disabled = true
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          let cert = this.$refs.orgCert.getFileRaw()
          let key = this.$refs.orgKey.getFileRaw()
          if (!cert || !key) {
            this.disabled = false
            return
          }
          await this.uploadCa(cert, key)

          let submitCertFn = setInterval(() => {
            if (this.CaCert != 'CaCert' && this.CaKey != 'CaCert') {
              this.$apis.certificate
                .importOrgCert(this.editForm)
                .then(res => {
                  this.$message.success('组织证书导入成功!')
                  this.$emit('update:list')
                  this.handleCancel()
                })
                .catch(err => {
                  this.disabled = false
                })
              clearInterval(submitCertFn)
            }
          }, 500)
        } else {
          this.$message.warning('请填写内容')
          this.disabled = false
          return
        }
      })
    },
    // 上传组织ca证书和私钥
    uploadCa(cert, key) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('name', cert.name)
        formData.append('file', cert.raw)
        let formData1 = new FormData()
        formData1.append('name', key.name)
        formData1.append('file', key.raw)
        let arr = [
          { name: 'CaCert', data: formData },
          { name: 'CaKey', data: formData1 }
        ]
        arr.map((ele, index) => {
          this.$apis.certificate
            .uploadCertificateFile(ele.data)
            .then(res => {
              if (res.data) {
                this.$set(this.editForm, ele.name, res.data)
                if (index === arr.length - 1) {
                  resolve(true)
                }
              }
            })
            .catch(err => {
              this.$message.error(`文件${ele.name}上传失败`)
              reject(false)
              return
            })
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.import-org-cert-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-width);
  }

  .el-form {
    margin-right: var(--base-font-size-common);
  }
}
</style>
